/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Office_DescriptionInputs */

const en_map_office_description = /** @type {(inputs: Map_Office_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small office building. Two TinyRobots, two motorized doors, one beverage dispenser.`)
};

const fr_map_office_description = /** @type {(inputs: Map_Office_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petit bâtiment de bureaux. Deux TinyRobot, deux portes motorisées, une station de boissons.`)
};

const ms_sg2_map_office_description = /** @type {(inputs: Map_Office_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangunan pejabat kecil. Dua TinyRobot, dua pintu bermotor, satu pengeluar minuman.`)
};

/**
* | output |
* | --- |
* | "Small office building. Two TinyRobots, two motorized doors, one beverage dispenser." |
*
* @param {Map_Office_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_office_description = /** @type {((inputs?: Map_Office_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Office_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_office_description(inputs)
	if (locale === "fr") return fr_map_office_description(inputs)
	return ms_sg2_map_office_description(inputs)
});